import { Popover } from '@shopify/polaris';
import { useState } from 'react';
import { ColorPicker, IColor, useColor } from 'react-color-palette';
import TooltipWithAction from '../TooltipWithAction';
import CustomBadge from '../CustomBadge';
import styled from 'styled-components';
interface ColorButtonProps {
  selectedColor: string;
  setSelectedColor: (color: string) => void;
  instanceId: string;
  disabled?: boolean;
}

const ColorButton = ({ selectedColor, setSelectedColor, instanceId, disabled }: ColorButtonProps) => {
  const [active, setActive] = useState(false);
  const [color, setColor] = useColor(selectedColor || '');

  const handleColorSelect = (newColor: IColor) => {
    setSelectedColor(newColor.hex);
    setColor(newColor);

    const timeoutId = setTimeout(() => {
      document.execCommand('foreColor', false, newColor.hex);
    }, 500);

    return () => clearTimeout(timeoutId);
  };

  const styleActivator = {
    width: '18px',
    height: '18px',
    borderRadius: '50%',
    color: 'transparent',
    transform: 'translate(4px, 0px)',
    backgroundColor: selectedColor,
    border: '0.5px dashed #9f9e9e',
  };

  const componentForActivator = () => {
    return disabled ? (
      <TooltipWithAction activatorWrapper="div" content={<CustomBadge marginLeft={false} />}>
        <button className="rsw-btn">
          <div style={{ ...styleActivator, opacity: 0.5 }}>.</div>
        </button>
      </TooltipWithAction>
    ) : (
      <button className="rsw-btn" onClick={() => setActive(!active)}>
        <div data-editor-id={instanceId} style={styleActivator}>
          .
        </div>
      </button>
    );
  };

  return (
    <Popover active={active} activator={componentForActivator()} onClose={() => setActive(false)}>
      <ColorPickerStyled>
        <ColorPicker color={color} onChange={handleColorSelect} height={100} hideAlpha disabled={disabled} />
      </ColorPickerStyled>
    </Popover>
  );
};

export default ColorButton;

const ColorPickerStyled = styled.div`
  padding: 12px;
  min-width: 260px;
  .rcp-fields .rcp-fields-floor:nth-of-type(2) {
    display: none !important;
  }

  .rcp-fields .rcp-field-label {
    display: none !important;
  }
`;
